import { Button, Text } from '@homebotapp/hb-react-component-catalog'

interface GoalProps {
  onClick: (goal: string) => void
  selectedGoals: string[]
  goal: string
  copy: string
  icon: string // emoji
}

export const Goal = ({ onClick, selectedGoals, goal, copy, icon }: GoalProps) => {
  const isSelected = selectedGoals.includes(goal)
  return (
    <Button
      data-qa={goal}
      display='flex'
      alignItems='center'
      justifyContent='start'
      gap={4}
      key={goal}
      onClick={() => onClick(goal)}
      bgColor={isSelected ? 'primary.500' : 'transparent'}
      _hover={isSelected ? { bgColor: 'primary.500' } : { bgColor: 'neutral.200' }}
    >
      {icon}
      <Text color='neutral.900' mb={0}>
        {copy}
      </Text>
    </Button>
  )
}
